// frontend/src/services/api/modules/users.js
import { API_URL } from '../config';
import { getAuthHeaders, fetchWrapper } from '../utils/fetchWrapper';

export const crearUsuario = async (userData) => {
  try {
    const resp = await fetchWrapper(`${API_URL}/api/usuarios`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userData),
    });
    if (!resp.ok) {
      const errorData = await resp.json().catch(() => ({}));
      return { error: errorData.error || "Error al crear usuario" };
    }
    return await resp.json();
  } catch (error) {
    console.error("Error creando usuario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const obtenerUsuarioPorId = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${encodeURIComponent(userId)}`, {
      method: "GET",
      headers, 
    });

    if (!resp.ok) {
      const errorData = await resp.json().catch(() => ({}));
      return { error: errorData.error || "Error al obtener usuario" };
    }

    const respuestaCompleta = await resp.json();
    // CORREGIR: Extraer solo la data, similar a buscarUsuarioPorCorreo
    return respuestaCompleta.data || respuestaCompleta;
  } catch (error) {
    console.error("Error en obtenerUsuarioPorId:", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const updateUsuario = async (userId, userData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${encodeURIComponent(userId)}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(userData),
    });
    if (!resp.ok) {
      const errorData = await resp.json().catch(() => ({}));
      return { error: errorData.error || "Error al actualizar usuario" };
    }
    return await resp.json();
  } catch (error) {
    console.error("Error en updateUsuario:", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const obtenerUsuarioPorCodigoAcceso = async (codigoAcceso) => {
  try {
    const resp = await fetchWrapper(
      `${API_URL}/api/usuarioPorCodigoAcceso?code=${encodeURIComponent(codigoAcceso)}`
    );
    if (!resp.ok) {
      const err = await resp.json().catch(() => ({}));
      return {
        error: err.error || "Error al obtener usuario por código de acceso",
      };
    }
    return await resp.json();
  } catch (error) {
    console.error("Error en obtenerUsuarioPorCodigoAcceso:", error);
    return { error: "Error de conexión o de red" };
  }
};

export const buscarUsuarioPorCorreo = async (email) => {
  try {
    const resp = await fetchWrapper(
      `${API_URL}/api/usuarios/porCorreo?email=${encodeURIComponent(email)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (resp.ok) {
      const { data } = await resp.json();
      return {
        status: 200,
        data,
      };
    } else if (resp.status === 404) {
      return { status: 404 };
    } else {
      const errData = await resp.json().catch(() => ({}));
      return {
        status: resp.status,
        error: errData.error || "Error buscando usuario por correo",
      };
    }
  } catch (error) {
    console.error("Error en buscarUsuarioPorCorreo:", error);
    return { status: 500, error: "Error de conexión con el servidor" };
  }
};